import React from "react";
import Navbar from "../components/Navbar";

const NotFound = () => {
  return (
    <div style={{ backgroundColor: "#000000", minHeight: "100vh" }}>
      <Navbar forceDarkMode={true} />
      <div className="utility-page-wrap">
        <div className="login-form-wrapper red">
          <div className="_404">
            <div className="_404-title">
              <h2 className="title" style={{ color: "#ffffff" }}>404 Oops!</h2>
              <p style={{ color: "rgba(255, 255, 255, 0.7)" }}>
                Well well well, it looks like you stumbled upon a 404 error!
                Don&#x27;t worry, it&#x27;s not your fault - the page
                you&#x27;re looking for must have gone on a wild adventure and
                gotten lost somewhere.
              </p>
            </div>
            <a href="/" className="button w-button">
              Go Home
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
